
import * as reactiveUtils from '@arcgis/core/core/reactiveUtils';
import FeatureLayer from "@arcgis/core/layers/FeatureLayer"
import Query from "@arcgis/core/rest/support/Query"
import { layer } from '@fortawesome/fontawesome-svg-core';
import { internallayerNameList } from './config';

export const handleLoadedLayers = async(map)=>{
  let ocLandInsightsID= await ocLandInsightsIdHandler(map)
    let externalLayerArray = map.allLayers.filter(layer=>layer?.customParameters?.OCLandInsightsID === ocLandInsightsID['parcelsExternal'])
    let parcelExternal
    let internalLayerArray= map.allLayers.filter(layer=>layer?.customParameters?.OCLandInsightsID === ocLandInsightsID['parcelsInternal'])
    let parcelInternal
    if(externalLayerArray.length=== 1){
      parcelExternal=externalLayerArray.getItemAt(0)
    }
    
    if (internalLayerArray.length === 1) {
      parcelInternal=internalLayerArray.getItemAt(0)
    }
    if(parcelInternal && parcelExternal){
      if(parcelInternal.loaded){
        ocLandInsightsID["parcels"]=ocLandInsightsID['parcelsInternal']
        parcelExternal.parent.remove(parcelExternal)
      }else{
        ocLandInsightsID["parcels"]=ocLandInsightsID['parcelsExternal']
        parcelInternal.parent.remove(parcelInternal)
      }
    } 
    await removeHistoricAerialGroup(map);
    await removeFailedLayersInArray(map, internallayerNameList, ocLandInsightsID);
    
    return ocLandInsightsID
}

const removeFailedLayersInArray = async (map,layerArray,ocLandInsightsID) => {
  layerArray.forEach(async item=>{
    let layer = map.allLayers.find(l=>l?.customParameters?.OCLandInsightsID === ocLandInsightsID[item]);
    await removeLayerOnFail(layer)
  })

}

const removeHistoricAerialGroup=async (map,groupName="Historical Eagle Aerial Imagery") => {
  const layer = map.layers.find(layer => layer?.title === groupName);
  if(!layer){
    return
  }
  await layer.when()
  if(layer?.title===groupName){
    
    if(layer.allLayers.length===0){
      map.remove(layer);
    }
    layer.allLayers.forEach(async(subLayer:any)=>{
      try {
        await subLayer.when()
      } catch (error) {
        layer.remove(subLayer)
      }
    })
    reactiveUtils.once(()=>{
      
      return [!layer.allLayers.length]
    })
    .then(([length])=>{
      if(layer.title===groupName){
        map.remove(layer);
      }
    })
  }
}

const removeLayerOnFail = async (layer) => {
  try {
    await layer.when();
  } catch (error) {
    const parent = await layer.parent.when();
    reactiveUtils.once(() => {
      return [!parent.allLayers.length];
    }).then(([length]) => {
      parent.parent.remove(parent);
    });
    parent.remove(layer);
  }
};

export const ocLandInsightsIdHandler=async(map)=>{
  let OCLandInsightsIdDictionary={}
let idCheckTable:FeatureLayer=map.allTables.find((layer)=>{
  return layer.layerId===900006
});
if(idCheckTable){
  let query:Query = new Query({
where:'1=1',
outFields:['*']
});
try {
  let Table=await idCheckTable.queryFeatures(query);
map.allLayers.forEach((layer)=>{
  Table.features.forEach((feature)=>{
    if(layer.layerId && feature.attributes['OCLandInsightsID']){
    if(layer.layerId===Number(feature.attributes['OCLandInsightsID'])){
      OCLandInsightsIdDictionary[feature.attributes.LayerName]=Number(feature.attributes['OCLandInsightsID'])
      layer.customParameters={OCLandInsightsID:Number(feature.attributes['OCLandInsightsID']),
      isLabelLayer:feature.attributes['isLabelLayer']}
    }}
  })
  
});
map.allTables.forEach((table)=>{
  Table.features.forEach((feature)=>{
    if(table.layerId && feature.attributes['OCLandInsightsID']){
    if(table.layerId===Number(feature.attributes['OCLandInsightsID'])){
      OCLandInsightsIdDictionary[feature.attributes.LayerName]=Number(feature.attributes['OCLandInsightsID'])
      table.customParameters={OCLandInsightsID:Number(feature.attributes['OCLandInsightsID'])}
    }}
  })
})
} catch (error) {
  window.location.href=`${process.env.REACT_APP_BASE_DOMAIN_URL}/500`;
}

return OCLandInsightsIdDictionary
}
else{
  window.location.href=`${process.env.REACT_APP_BASE_DOMAIN_URL}/500`;
}
}

